import { Button, Col, TabContent, TabPane } from 'reactstrap';
import ProductOne from './ProductOne';
import ProductTwo from './ProductTwo';
import ProductThree from './ProductThree';
import ProductFour from './ProductFour';
import ProductFive from './ProductFive';
import { useAppSelector } from '../../../../../../ReduxToolkit/Hooks';
import CommonButton from '../CommonButton/CommonButton';
import { useNavigate, useParams } from 'react-router-dom';
import { Product } from '../../../../../../Types/Products';
import { useEffect, useState } from 'react';
import { productCategoriesApi, productsApi } from '../../../../../../Api';
import { notification } from 'antd';
import { handleUploadFiles } from '../../../../../../utils/helper/functions';
import { toast } from 'react-toastify';

const ProductTabContent = () => {
    const { navId } = useAppSelector((state) => state.addProduct);
    const { id } = useParams();
    const navigate = useNavigate();
    const [uploadFiles, setUploadFiles] = useState<File[]>([]);
    const [categories, setCategories] = useState<any[]>([]);
    const [productDetail, setProductDetail] = useState<Product>({
        name: '',
        description: '',
        price: 0,
        original_price: 0,
        in_stock: true,
        brand: '',
        seller: '',
        fabric: '',
        colors: [],
        images: [],
        rating: 0,
        reviewCount: 0,
        category_id: 1,
        product_in_stock: 0
    });
    const [loadingProductDetail, setLoadingProductDetail] = useState(false);
    const handleSetProductDetail = (e: any) => {
        setProductDetail({ ...productDetail, ...e });
    };

    const getDetail = () => {
        setLoadingProductDetail(true);
        productsApi
            .getDetail(Number(id))
            .then((res) => {
                setProductDetail({...res.data, original_price: Number(res.data.original_price), price: Number(res.data.price) });
                setLoadingProductDetail(false);
            })
            .catch((err) => {
                console.error(err);
            });
    };

    const createProduct = (imgUrls: string[]) => {
        const data: any = {};
        if (imgUrls.length > 0) {
            data.images = imgUrls;
        }
        productsApi
            .create({ ...productDetail, ...data })
            .then((res) => {
                toast.success("Create success");
                navigate(`/products`);
            })
            .catch((err) => {
                console.error(err);
                toast.warning("Something has occurred !!!");
            });
    };

    const updateproduct = (imgUrls: string[]) => {
        setLoadingProductDetail(true);
        const data: any = {};
        if (imgUrls.length > 0) {
            data.images = imgUrls;
        }
        productsApi
            .update(Number(id), { ...productDetail, ...data })
            .then((res) => {
                setProductDetail(res.data);
                setLoadingProductDetail(false);
                toast.success("Update success");
            })
            .catch((err) => {
                console.error(err);
                toast.warning("Something has occurred !!!");               
            });
    };

    const formSubmit = async () => {
        if (productDetail.name && productDetail.price && productDetail.original_price) {
            const imgUrls = await handleUploadFiles(uploadFiles);
            if (id) {
                updateproduct(imgUrls);
            } else {
                createProduct(imgUrls);
            }
        } else
            toast.warning("Missing required fields !!!");
    };

    useEffect(() => {
        productCategoriesApi.getList().then((res: any) => {
            setCategories(res.data.data);
            // setProductDetail({
            //     ...productDetail,
            //     ...{ category_id: Number(res.data.data[0].id) }
            // });
        });

        if (id) {
            getDetail();
        }
    }, []);

    return (
        <Col
            xxl="9"
            xl="8"
            className="box-col-8 position-relative">
            <TabContent activeTab={navId}>
                <TabPane tabId={1}>
                    <ProductOne
                        productName={productDetail.name}
                        productDescription={productDetail.description}
                        setProducDetail={handleSetProductDetail}
                    />
                </TabPane>
                <TabPane tabId={2}>
                    <ProductTwo images={productDetail.images} setUploadFiles={setUploadFiles} />
                </TabPane>
                <TabPane tabId={3}>
                    <ProductThree
                        categories={categories}
                        colors={productDetail.colors}
                        price={productDetail.price}
                        category_id={productDetail.category_id}
                        orginalPrice={productDetail.original_price}
                        productInStock={productDetail.product_in_stock}
                        setProductDetail={handleSetProductDetail}
                    />
                </TabPane>
                {/* <TabPane tabId={4}>
                    <ProductFour />
                </TabPane> */}
                <TabPane tabId={5}>
                    <ProductFive
                        brand={productDetail.brand}
                        fabric={productDetail.fabric}
                        seller={productDetail.seller}
                        in_stock={productDetail.in_stock}
                        sku={productDetail.sku}
                        zip_code={productDetail.zip_code}
                        city={productDetail.city}
                        weight={productDetail.weight}
                        shipping_class={productDetail.shipping_class}
                        setProductDetail={handleSetProductDetail}
                    />
                </TabPane>
            </TabContent>
            {navId == 5 && <CommonButton formSubmit={formSubmit} />}
        </Col>
    );
};

export default ProductTabContent;
